<template>
  <div style="margin-top:1px;">
    <el-button class="green" plain icon="el-icon-fa-file-excel-o" @click="handleExport('xls','page', 'export')">本页</el-button>
    <el-button class="green" plain icon="el-icon-fa-file-excel-o" @click="handleExport('xls','full', 'export')">全部</el-button>
    <el-button class="red" plain icon="el-icon-fa-file-pdf-o" @click="handleExport('pdf','page', 'export')">本页</el-button>
    <el-button class="red" plain icon="el-icon-fa-file-pdf-o" @click="handleExport('pdf','full', 'export')">全部</el-button>
  </div>
</template>

<script>
  export default {
    name: "export-ctrl",
    props: {},
    methods: {
      handleExport(down, mode, agile) {
        this.$emit("export", {down, mode, agile});
      }
    }
  };
</script>

<style>
</style>
